import { List, Typography } from 'antd';

const { Text } = Typography;

const Otif = () => {

  const data = [
    'Diğer 2 başlıkta olan kurallar bunun için de geçerlidir.',
    'Bir siparişin tüm ürünleri toplanıp iadesiz teslim edilmesine rağmen zamanında teslim edilmemiş ise bu KPI için o sipariş başarısız sayılır.',
    'Bir sipariş zamanında teslim edilmesine rağmen içerisinde poşet hariç en az 1 ürün toplanmamış veya tam toplanıp iadeli teslim edilmiş ise bu KPI için o sipariş başarısız sayılır.',
    'Normal şartlarda teslim edilen siparişler orana yansır ancak teslimata kadar siparişin başarısız olduğu kesinleşmiş ise doğrudan oranı etkiler.',
    'Siparişin tümü iptal edilmiş ise buraya yansımaz.',
    'Günlük performansta 00:00’dan itibaren bakılan ana kadar işlem gören ve görmesi gereken siparişler üzerinden oran gösterilir.',
    'Aylık performansta ilgili ayın 1’inden itibaren o ana kadar olan siparişler üzerinden oran gösterilir.',
    'İlgili oran merkez tarafından belirlenen hedef değerinden daha yüksekse yeşil, düşükse kırmızı renk ile gösterilir.'
  ];

  return (<List
      className="demo-loadmore-list"
      itemLayout="horizontal"
      dataSource={data}
    >
      <List.Item.Meta
        style={{ marginBottom: 10 }}
        title={
          <Text strong style={{ fontSize: 16 }}>
            İlgili dağıtım tarihine ait siparişlerin ne kadarının hem eksiksiz toplanıp hem de
            iadesiz ve zamanında teslim edildiğini gösteren orandır.
          </Text>
        }
      />
      <ul>
        {data.map((item, index) => (<li style={{ color: '#555555', fontWeight: 500 }} key={index}>{item}</li>))}
      </ul>
    </List>
  );
};

export default Otif;

